import { render, staticRenderFns } from "./VTaskGroupControl.vue?vue&type=template&id=8a0ff44a&"
import script from "./VTaskGroupControl.vue?vue&type=script&lang=ts&"
export * from "./VTaskGroupControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports